import { toast } from "react-hot-toast";
import { Toast } from "@/components/atoms";

export const addToast = (
  type: "success" | "danger" | "info",
  message: string,
  duration = 5000,
  options?: { replace?: boolean; id?: string }
) => {
  const toastId = options?.id ?? "global-toast";

  if (options?.replace) {
    toast.dismiss(toastId);
  }

  toast.custom(
    (t) => (
      <Toast
        type={type}
        message={message}
        onClick={() => toast.dismiss(t.id)}
        visible={t.visible}
      />
    ),
    {
      duration,
      id: options?.replace ? toastId : undefined,
    }
  );
};